/**
 * Calendar Service
 *
 * Exposes the app-wide {@link ICalendarService} instance — Supabase is the
 * only implementation (mock mode was removed app-wide).
 *
 * @module features/family-calendar/services/calendarService
 */

import type { ICalendarService } from './calendarService.types';
import { SupabaseCalendarService } from './supabaseCalendarService';

/**
 * Calendar service instance — Supabase-backed.
 *
 * @example
 * ```typescript
 * import { calendarService } from '@/features/family-calendar/services/calendarService';
 *
 * // Get all calendars
 * const calendars = await calendarService.getCalendars();
 *
 * // Create a new event. `calendarId` must be a real calendar uuid — the
 * // column is `events.calendar_id uuid NOT NULL`, so any placeholder string
 * // is rejected by `createEvent` before it can reach the database or the
 * // offline replay queue. Read it from the store
 * // (`selectWritableCalendarId`), never write one by hand.
 * const event = await calendarService.createEvent({
 *   calendarId: calendars[0].id,
 *   title: 'Рожден ден',
 *   startDate: '2025-03-15',
 *   isAllDay: true,
 * });
 * ```
 */
export const calendarService: ICalendarService = new SupabaseCalendarService();

// Export class for testing purposes
export { SupabaseCalendarService };

// Re-export types
export type {
  AddMemberDTO,
  CreateCalendarDTO,
  CreateEventDTO,
  CreateLabelDTO,
  DateRange,
  ICalendarService,
  UpdateCalendarDTO,
  UpdateEventDTO,
  UpdateLabelDTO,
} from './calendarService.types';
